import { TypeOfBenefit } from '__generated__/api';

const isTypeOfBenefitForPension = (typeOfBenefit: string | TypeOfBenefit) =>
  typeOfBenefit === TypeOfBenefit.OldAgeInsurance ||
  typeOfBenefit === TypeOfBenefit.Insurance ||
  typeOfBenefit === TypeOfBenefit.PrePension ||
  typeOfBenefit === TypeOfBenefit.OldAgePension;

export default isTypeOfBenefitForPension;
